export default class Installments {
  constructor() {
    this.$installments = document.querySelectorAll('.js-installment-item');

    this.init();
  }

  init() {
    this.$installments && this.$installments.forEach((installment) => {
      installment.addEventListener('click', (e) => {
        e.preventDefault();

        const $installment = e.currentTarget;

        if ($installment.classList.contains('active')) {
          return;
        }

        const $wrapper = $installment.closest('.js-installments');

        $wrapper.querySelectorAll('.js-installment-item').forEach((installmentContent) => {
          if (installmentContent.classList.contains('active')) {
            installmentContent.classList.remove('active');
          }
        });
        
        $installment.querySelector('input[type="radio"]').checked = true;
        $installment.classList.add('active');
      });
    });
  }
}


/** WEBPACK FOOTER **
 ** ./assets/js/modules/installments.js
 **/